"use client";

import { useState } from "react";

import Niche from "./Niche";
import { FaXTwitter, FaFacebookF } from "react-icons/fa6";
import IMG from "../../assets/images/bg.png";
import { TextReveal } from "./TextReveal";
import Footer from "../footer";
import {
  FaEnvelope,
  FaPhone,
  FaMapMarkerAlt,
  FaClock,
  FaTwitter,
  FaYoutube,
  FaLinkedinIn,
  FaInstagram,
} from "react-icons/fa";
import ContactUsx from "./ContactUsx";
import { IconButton } from "@mui/material";
import FAQ from "../FAQ/FAQ";
import PerksSection from "./Perks";
import { WhatWeOffer } from "./BentoGrid/WhatWeOffer";

const HomeOwner = () => {
  const [animationDone, setAnimationDone] = useState(false);

  return (
    <div className="relative min-h-screen ">
      {!animationDone && <Niche onFinish={() => setAnimationDone(true)} />}

      {animationDone && (
        <main className="  w-full  bg-gray-200">
          <section className="flex flex-col items-center justify-center min-h-screen bg-gray-200 px-8 md:px-20">
            <div className="max-w-7xl mx-auto text-center pt-100 lg:pt-250">
              <h1
                style={{ fontFamily: "Playfair Display, sans-serif" }}
                className="text-4xl md:text-7xl font-semibold text-[#7C3A21] leading-tight"
              >
                VVIP Access to India’s
                <br /> Top 1% Home Owners
              </h1>
              <p className="mt-6 text-lg md:text-xl text-gray-700">
                Reserve a slot and relax — <br />
                we’ll handle the calls, site visits, and paperwork.
              </p>

              <button className="mt-8 my-4 px-6 py-3 bg-black text-white rounded-xl border border-white shadow hover:shadow-md transition">
                <a href="/contact"> Get Access </a>
              </button>
            </div>
            <img className="max-w-7xl mx-auto w-full" src={IMG} alt="" />
            <TextReveal className="mx-auto ">
              Your home is more than just a property — it’s an investment in
              your future. We’re here to elevate that investment. With
              exceptional listings and discerning buyers, we ensure your home
              gets the attention it truly deserves. Our expertise and
              connections will unlock the true value of your property, allowing
              you to take the next step with confidence.
            </TextReveal>

            <PerksSection />
            <div
              style={{
                padding: "  10px",
              }}
              className="flex justify-center items-center flex-col"
            >
              <h2
                style={{
                  fontSize: 40,
                  marginBottom: 30,
                  fontFamily: "Playfair Display, sans-serif",
                }}
                className="text-center text-lg font-bold leading-none text-[#7C3A21]    "
              >
                What makes us unique in the market
              </h2>
              <h2 className="text-center text-md w-full md:w-[50vw] leading-normal align-center mb-10 font-semibold leading-none text-gray-900">
                Exclusive properties from 2 crore, personalized support, no spam
                calls, professional video tours, and visits for qualified buyers
                only. Experience a tailored property search.
              </h2>
              <WhatWeOffer />
            </div>

            <div className="rounded-lg  p-4 lg:p-20 gap-10 mb-10 max-w-7xl w-full grid grid-cols-1 md:grid-cols-2 bg-gradient-to-r from-blue-500 to-blue-400      ">
              {/* Contact Info */}
              <div className="text-white flex flex-col justify-between max-w-sm">
                <h2 className="text-3xl font-bold mb-4">Contact us</h2>
                <p className="mb-8">
                  Leave your email and we will get back to you within 24 hours
                </p>

                <div className="space-y-4">
                  <div className="flex items-center gap-3">
                    <FaEnvelope className="text-xl" />
                    <div>
                      <p className="text-sm">Email</p>
                      <p className="font-semibold">info@resell.properties</p>
                    </div>
                  </div>

                  <div className="flex items-center gap-3">
                    <FaPhone className="text-xl" />
                    <div>
                      <p className="text-sm">Phone</p>
                      <p className="font-semibold">+91 8884769695</p>
                    </div>
                  </div>

                  <div className="flex items-center gap-3">
                    <FaMapMarkerAlt className="text-xl" />
                    <div>
                      <p className="text-sm">Address</p>
                      <p className="font-semibold">
                        Koramangala,Bengaluru,India
                      </p>
                    </div>
                  </div>

                  <div className="flex items-center gap-3">
                    <FaClock className="text-xl" />
                    <div>
                      <p className="text-sm">Working hours</p>
                      <p className="font-semibold">09:00 a.m. – 07:00 p.m.</p>
                    </div>
                  </div>
                </div>

                {/* Social icons */}
                <div className="flex gap-4 mt-8 text-2xl">
                  <IconButton type="submit" edge="start">
                    <a
                      href="https://www.linkedin.com/company/homznoffiz/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-gray-700 transition hover:opacity-75"
                    >
                      <FaLinkedinIn size={30} color="white" />
                    </a>
                  </IconButton>
                  <IconButton type="submit" edge="start">
                    <a
                      href="https://www.instagram.com/homznoffiz/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-gray-700 transition hover:opacity-75"
                    >
                      <FaInstagram size={30} color="white" />
                    </a>
                  </IconButton>
                  <IconButton type="submit" edge="start">
                    <a
                      href="https://x.com/homznoffiz"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-gray-700 transition hover:opacity-75"
                    >
                      <FaXTwitter size={30} color="white" />
                    </a>
                  </IconButton>
                  <IconButton type="submit" edge="start">
                    <a
                      href="https://www.youtube.com/c/HomznoffizBestPropertyAdvisorinIndia"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="text-gray-700 transition hover:opacity-75"
                    >
                      <FaYoutube size={30} color="white" />
                    </a>
                  </IconButton>
                </div>
              </div>

              <ContactUsx />
            </div>
            <FAQ />
          </section>

          <Footer />
        </main>
      )}
    </div>
  );
};
export default HomeOwner;
